var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppletv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 24,
    viewBox: "0 0 66 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8983 3.77674C13.7595 2.71672 14.1703 1.3652 14.051 0.0136719C12.726 0.146174 11.4937 0.782187 10.6192 1.78921C9.74471 2.76972 9.2942 4.055 9.38695 5.36677C10.7252 5.41977 12.037 4.82351 12.8983 3.77674Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8983 3.68357C13.733 2.65005 14.1438 1.32502 14.051 0C12.726 0.132502 11.4937 0.768513 10.6192 1.77553C9.74471 2.75605 9.2942 4.04132 9.38695 5.3531C10.7517 5.39285 12.0503 4.77009 12.8983 3.68357Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0233 5.57861C12.1152 5.45936 10.4854 6.66513 9.61093 6.66513C8.73642 6.66513 7.30539 5.63161 5.78161 5.65811C3.76758 5.71111 1.93904 6.83738 0.985026 8.59967C-1.08201 12.1507 0.441767 17.4508 2.4558 20.2864C3.42307 21.7572 4.58909 23.2279 6.13937 23.2279C7.68965 23.2279 8.16666 22.2872 9.94219 22.2872C11.7177 22.2872 12.2212 23.2279 13.7715 23.2014C15.3218 23.1749 16.3686 21.7306 17.3358 20.3394C18.0248 19.3324 18.5548 18.2193 18.9259 17.0533C17.0443 16.2186 15.8385 14.3503 15.8518 12.2965C15.8783 10.4944 16.8323 8.82492 18.3693 7.88415C17.3888 6.49287 15.812 5.63161 14.116 5.57861",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.09 3.69531V7.36563H32.0315V9.89643H29.09V18.5091C29.09 19.8474 29.673 20.4701 30.9847 20.4701C31.3425 20.4701 31.687 20.4436 32.0448 20.3906V22.9082C31.4618 23.0142 30.8655 23.0672 30.2692 23.0539C27.1024 23.0539 25.8569 21.8614 25.8569 18.8403V9.93618H23.6309V7.36563H25.8967V3.69531H29.09Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8034 23.0157H39.3848L33.7402 7.36719H37.1588L41.0809 19.8489L45.0559 7.36719H48.4083L42.8034 23.0157Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8987 13.6354H59.6711V7.39453H56.7031V13.6354H50.502V16.5637H56.7031V22.8443H59.6711V16.5637H65.8987V13.6354Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppletv);
export default __webpack_public_path__ + "static/media/appletv.bf6149d9e44b987c1a8fe637830f4545.svg";
export { ForwardRef as ReactComponent };